<template>
  <section class="container content-padding">
    <template v-if="!successRegister">
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-12">
            <h4>ระบุข้อมูลโปรไฟล์</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="id_card_number"><span style="color: red;">*</span> เลขที่บัตรประชาชน </label>
              <input type="number" class="form-control" required min="0" ref="idCardNumber"
                     onKeyPress="if(this.value.length==13) return false;"
                     @keypress="filterOnlyNumber($event)"
                     v-model="form.id_card_number">
              <small class="form-text text-muted">ไม่ต้องใส่เครื่องหมายขีด (-)</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="prefixName"><span style="color: red;">*</span> คำนำหน้าชื่อ</label>
              <select name="prefixName"
                      class="form-control" id="prefixName"
                      required
                      v-model="form.title_th">
                <option :value="null">เลือกคำนำหน้าชื่อ</option>
                <option v-for="(item,index) in prefixNames" :value="item" :key="index">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="name"><span style="color: red;">*</span> ชื่อ-สกุล (ตามบัตรประชาชน)</label>
              <input type="text"
                     class="form-control" required
                     id="name"
                     name="name"
                     v-model="form.name">
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="tel"><span style="color: red;">*</span> เบอร์โทร</label>
              <input type="number"
                     class="form-control" required
                     id="tel" @keypress="filterOnlyNumber($event)"
                     name="tel"
                     v-model="form.tel">
              <small class="form-text text-muted">ไม่ต้องใส่เครื่องหมายขีด (-)</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="birthday_date"><span style="color: red;">*</span> วัน-เดือน-ปีเกิด</label>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <select name="birthday_date"
                      class="form-control"
                      id="birthday_date"
                      required
                      v-model="form.birthday_date">
                <option :value="null">วัน</option>
                <option v-for="(day,index) in days" :value="day" :key="index">
                  {{ day }}
                </option>
              </select>
            </div>
          </div>


          <div class="col-4">
            <div class="form-group">
              <select name="bMonth"
                      class="form-control" id="birthday_month"
                      required
                      v-model="form.birthday_month">
                <option :value="null">เดือน</option>
                <option v-for="(month,index) in months" :value="(index + 1)" :key="index">
                  {{ month }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <select name="birthday_year" id="birthday_year"
                      class="form-control"
                      required
                      v-model="form.birthday_year">
                <option :value="null">ปีพ.ศ.</option>
                <option v-for="(year,index) in years" :value="year" :key="index">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label for="province"><span style="color: red;">*</span> จังหวัด และเขต/อำเภอที่ฉันอยู่ (ปัจจุบัน)</label>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <select v-model="form.province_id"
                      class="form-control"
                      id="province"
                      @change="onChangeProvince($event)"
                      required
                      name="province">
                <option :value="null">{{ $t('message.booking.contact_step.set_province') }}</option>
                <option :value="addressProvince.id" v-for="(addressProvince, index) in sortedProvinces">
                  {{ addressProvince | multiLangName }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-6">
            <div class="form-group">
              <select v-model="form.district_id"
                      class="form-control"
                      required
                      id="district" name="district">
                <option :value="null">{{ $t('message.booking.contact_step.set_district') }}</option>
                <option :value="district.id" v-for="(district, index) in sortedDistricts">
                  {{ district | multiLangName }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>ข้อมูลทักษะและภาษา</label>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-6">
            <h3>ทักษะของฉัน</h3>
            <div class="py-1" v-for="(jobSkill, index) in jobSkills" :key="index">
              <label>
                <input type="checkbox" name="job_skills" v-model="form.job_skill_arr"
                       :value="jobSkill.id">&nbsp;&nbsp;{{ jobSkill.name }}
              </label>
            </div>
          </div>

          <div class="col-6">
            <h3>ภาษาที่ฉันสื่อสารได้</h3>
            <div class="py-1" v-for="(jobLanguage, index) in jobLanguages" :key="index">
              <label>
                <input type="checkbox" name="job_languages" v-model="form.job_language_arr"
                       :value="jobLanguage.id">&nbsp;&nbsp;{{ (jobLanguage.name === 'Thai') ? jobLanguage.native : jobLanguage.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h3>ท่านต้องการหางานประจำด้วยหรือไม่</h3>
            <div class="form-check">
              <input class="form-check-input" v-model="form.need_full_time"
                     type="radio" name="need_full_time" id="need_full_time1" :value="true">
              <label class="form-check-label" for="need_full_time1">
                ต้องการ
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-model="form.need_full_time"
                     type="radio" name="need_full_time" id="need_full_time2" :value="false">
              <label class="form-check-label" for="need_full_time2">
                ไม่ต้องการ
              </label>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12">
            <button class="btn btn-block btn-success" type="submit" :disabled="isLoading">
              {{ isLoading ? 'กำลังบันทึก...' : 'บันทึก' }}
            </button>
          </div>
        </div>


      </form>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-12 text-center">

          <h2>ลงทะเบียนสำเร็จแล้ว</h2>
          <a href="https://line.me/R/ti/p/%40beneatpro" class="btn btn-lg btn-success"
             @click.prevent="openLineRegister">ดำเนินการต่อ</a>
        </div>
      </div>
    </template>


  </section>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import i18n from '../../helpers/i18nHelpers'
import axios from 'axios'

export default {
  name: 'ProfessionalRegisterShortForm',
  data () {
    return {
      form: {
        id_card_number: null,
        title_th: null,
        name: null,
        tel: null,
        birthday_date: null,
        birthday_month: null,
        birthday_year: null,
        province_id: null,
        district_id: null,
        job_skill_arr: [],
        job_language_arr: [],
        need_full_time: true
      },
      days: [],
      months: [],
      years: [],
      jobSkills: [],
      jobLanguages: [],
      isLoading: false,
      successRegister: false,
      sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en'
    }
  },
  computed: {
    ...mapState({
      prefixNames: state => state.globalVal.prefixName,
      addressProvinces: state => state.addressProvince.addressProvinces,
      districts: state => state.addressProvince.districts
    }),
    sortedProvinces () {
      return _.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
    },
    sortedDistricts () {
      return _.orderBy(this.districts, [this.sortBy], ['asc'])
    },
    openLineRegister () {
      window.open('https://line.me/R/ti/p/%40beneatpro', '_blank')
    }
  },
  methods: {
    filterOnlyNumber (evt) {
      evt = evt || window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode
      // เอาเฉพาะตัวเลข และไม่เอา - หรือ . หรือ +
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode === 46 || charCode === 45 || charCode === 43)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    async submitForm () {
      this.successRegister = false
      if (this.form.id_card_number && this.form.id_card_number.length <= 12) {
        this.$refs.id_card_number.focus()
        this.$swal({ text: 'กรุณาระบุเลขบัตรประชาชนให้ครบ 13 หลัก', type: 'error' })
        return false
      }

      let nameSplit = this.form.name.split(' ')
      if (nameSplit.length <= 1) {
        this.$swal({ text: 'กรุณาระบุนามสกุล', type: 'error' })
        return false
      }

      const birthDate = this.getBirthDate()
      let params = { ...this.form }
      params.firstname = nameSplit[0]
      params.lastname = nameSplit[1] || ''
      params.birth_date = birthDate
      let { data } = await axios.post('/professionals/register/short', params)
      if (!data.error) {
        this.$swal({
          type: 'success',
          text: 'บันทึกสำเร็จ'
        })
        this.successRegister = true
      } else {
        this.$swal({ text: 'ผิดพลาดไม่สามารถบันทึกได้ กรุณาติดต่อทีมงาน', type: 'error' })
      }
    },
    async onChangeProvince (event = null) {
      let provinceId = event && event.target.value ? event.target.value : null
      this.form.district_id = null
      if (provinceId) {
        await this.fetchDistricts(provinceId)
      } else {
        this.$store.commit('addressProvince/SET_DISTRICTS', [])
      }
    },
    getBirthDate () {
      const year = this.form.birthday_year - 543
      const month = ('0' + this.form.birthday_month).slice(-2)
      const day = ('0' + this.form.birthday_date).slice(-2)
      return `${year}-${month}-${day}`
    },
    prepareBirthDate () {
      for (let i = 1; i <= 31; i++) {
        this.days.push(i)
      }
      this.months = [
        i18n.t('message.calendar.month.01'),
        i18n.t('message.calendar.month.02'),
        i18n.t('message.calendar.month.03'),
        i18n.t('message.calendar.month.04'),
        i18n.t('message.calendar.month.05'),
        i18n.t('message.calendar.month.06'),
        i18n.t('message.calendar.month.07'),
        i18n.t('message.calendar.month.08'),
        i18n.t('message.calendar.month.09'),
        i18n.t('message.calendar.month.10'),
        i18n.t('message.calendar.month.11'),
        i18n.t('message.calendar.month.12')
      ]
      const maxYear = new Date().getFullYear() + 543
      for (let i = 2490; i <= maxYear; i++) {
        this.years.push(i)
      }
    },
    async fetchDistricts (provinceId) {
      if (provinceId) {
        const queryData = {
          province_id: provinceId
        }
        await this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
      }
    },
    async fetchJobSkill () {
      let { data } = await axios.get('/job-users/job-skill')
      this.jobSkills = data.job_skill
    },
    async fetchJobLanguage () {
      let { data } = await axios.get('/job-users/job-language')
      this.jobLanguages = data.job_language
    }
  },
  mounted () {
    this.prepareBirthDate()
    this.onChangeProvince()
    this.fetchJobLanguage()
    this.fetchJobSkill()
    this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalRegisterShortForm.vue